class TestimonialsMediaCarousel extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.swiper');
  }

  connectedCallback() {
    this.initSwiper();
  }

  initSwiper() {
    const config = {
      slidesPerView: 1.2,
      spaceBetween: 20,
      loop: false,
      autoplay: false,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '"></span>';
        }
      },
      breakpoints: {
        480: {
          slidesPerView: 1.2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2.2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
        1400: {
          slidesPerView: 4,
          spaceBetween: 20,
        }
      }
    };

    new Swiper(this.slider, config);
  }
}

customElements.define('testimonials-media-carousel', TestimonialsMediaCarousel);


document.addEventListener('DOMContentLoaded', function () {
  const videoContainers = document.querySelectorAll('.video-container');

  videoContainers.forEach((videoContainer) => {
    const video = videoContainer.querySelector('.video-player');
    const muteButton = videoContainer.querySelector('.mute-button');
    const pauseButton = videoContainer.querySelector('.pause-button');
    const playButton = videoContainer.querySelector('.play-button');
    const progress = videoContainer.querySelector('.progress');

    muteButton.addEventListener('click', function (e) {
      e.stopPropagation();
      video.muted = !video.muted;
      updateMuteButton();
    });

    pauseButton.addEventListener('click', function (e) {
      e.stopPropagation();
      if (video.paused) {
        video.play();
        videoContainer.classList.remove('paused');
      } else {
        video.pause();
        videoContainer.classList.add('paused');
      }
      updatePauseButton();
    });

    video.addEventListener('timeupdate', function () {
      const percent = (video.currentTime / video.duration) * 100;
      progress.style.width = percent + '%';

      if (percent >= 100) {
        videoContainer.classList.add('paused');
        
      }
    });

    function updateMuteButton() {
      if (video.muted) {
          muteButton.innerHTML = `
              <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_2040_624)">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.49999 9.22655C4.23333 9.22655 3.99999 9.45988 3.99999 9.72655V15.8599C3.99999 16.1265 4.23333 16.3599 4.49999 16.3599H7.39999L11.7 20.6599C12 20.9599 12.5333 20.7599 12.5333 20.3265V17.0599C12.5333 16.9265 12.4667 16.7932 12.4 16.6932L5.06666 9.35988C4.96666 9.25988 4.83333 9.22655 4.69999 9.22655H4.49999ZM20.1 19.6932L18.2667 17.8599C18.9667 16.9932 20 15.2599 20 12.7932C20 8.99321 17.6 6.99321 17.6 6.99321C17.4 6.79321 17.0667 6.79321 16.8667 6.99321L16.4 7.45988C16.2 7.65988 16.2 7.99321 16.4 8.19321C16.4 8.19321 18.3 9.85988 18.3 12.7932C18.3 14.5932 17.6 15.8932 17.0333 16.6599L15.8333 15.4599C16.2 14.8932 16.6 13.9932 16.6 12.7932C16.6 10.5265 15.2333 9.35988 15.2333 9.35988C15.0333 9.15988 14.7 9.15988 14.5 9.35988L14.0333 9.82655C13.8333 10.0265 13.8333 10.3599 14.0333 10.5599C14.0333 10.5599 14.9 11.2265 14.9 12.7932C14.9 13.3932 14.7667 13.8599 14.6 14.2265L12.5 12.1265V5.25988C12.5 4.82655 11.9667 4.62655 11.6667 4.92655L8.49999 8.12655L5.09999 4.69321C4.89999 4.49321 4.59999 4.49321 4.39999 4.69321L3.93333 5.15988C3.73333 5.35988 3.73333 5.65988 3.93333 5.85988L5.33333 7.32655L14.2667 16.2599L18.9 20.8932C19.1 21.0932 19.4 21.0932 19.6 20.8932L20.0667 20.4265C20.3 20.2265 20.3 19.8932 20.1 19.6932Z" fill="white"/>
                </g>
                <defs>
                <clipPath id="clip0_2040_624">
                <rect width="16" height="16" fill="white" transform="translate(4 4.79321)"/>
                </clipPath>
                </defs>
              </svg>

          `;
      } else {
          muteButton.innerHTML = `
              <svg class="control-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11 5L6 9H2V15H6L11 19V5Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M19.07 4.93C20.9447 6.80528 21.9979 9.34836 21.9979 12C21.9979 14.6516 20.9447 17.1947 19.07 19.07M15.54 8.46C16.4774 9.39764 17.004 10.6692 17.004 11.995C17.004 13.3208 16.4774 14.5924 15.54 15.53" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
          `;
      }
    }
  
    function updatePauseButton() {
      if (!video.paused) {
          pauseButton.innerHTML = `
              <svg class="control-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10 4H6V20H10V4Z" fill="white"/>
                  <path d="M18 4H14V20H18V4Z" fill="white"/>
              </svg>
          `;
      } else {
          pauseButton.innerHTML = `
              <svg class="control-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 3L19 12L5 21V3Z" fill="white"/>
              </svg>
              
          `;
      }
    }

    // Click on video to play/pause
    videoContainer.addEventListener('click', function (e) {
      if (e.target.closest('.pause-button')) return;

      if (video.paused) {
        video.play();
        videoContainer.classList.remove('paused');
      } else {
        video.pause();
        videoContainer.classList.add('paused');
      }

      updatePauseButton();
    });
  });
});